import crypto from "crypto-browserify";
import * as CryptoJS from 'crypto-js';
import { Buffer } from "buffer";
import * as Yup from "yup";
import { SPECIAL_CHAR_NOT_ALLOWED, TOO_LONG, TOO_SHORT } from "@/utils/constants";
import { setSchoolName } from "@/redux/dataSlice";
import { setCurrentStep } from "@/redux/dataSlice";
import { datadogLogs } from '@datadog/browser-logs';

export const getImageType = (isMobile: boolean, data: any) => {
  if (isMobile) {
    if (
      data &&
      data.mobileimage &&
      Array.isArray(data.mobileimage.results) &&
      data.mobileimage?.results.length > 0
    ) {
      // return data.image.results[0].fileUrl;
      return data.mobileimage?.results?.[0]?.fileUrl;
    }
  } else {
    if (
      data &&
      data.image &&
      Array.isArray(data.image.results) &&
      data.image.results.length > 0
    ) {
      return data?.image?.results?.[0]?.fileUrl;
    }
  }
};

// provide comma to number
export const addCommas = (num: any) => {
  if (isNaN(num) || num < 20000) return num;

  let str = num.toString();

  let parts = str.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return parts.join(".");
};

export const phoneRegExp =
  // /^[\+]?((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  /^\+(?:[0-9] ?){11,15}[0-9]$/;

export const phoneRegExpHk = /^\+(?:[0-9] ?){10,15}[0-9]$/;

export const phoneRegExpSg = /^\b(?:6\d{7}|[89]\d{7})\b$/;

export const phoneRegExpCa = /^(?:\+1\s?)?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{4}$/;

export const phoneRegExp1 =
  /^[\+]?((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  // /^\+?1?\s?(\(?\d{3}\)?[\s-]?)?\d{3}[\s-]?\d{4}$/;

 export const regexUAE = /^(?:\+971|971)[0-9]{9}$/; 
//  export const regexUAE =  /^\+9715\d{8}$/; 
 export const regexInd = /^(?:\+91|91|0)?[6-9][0-9]{9}$/; 
 export const regPak = /^(?:\+92|92|0)?3[0-9]{8,9}$/; 
 export const phoneRegExpUsCa = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;
//  export const restCountry = /^(\+)?\d{8,18}$/;
//  export const restCountry = /^[+]?[1-9]{1}[0-9]{3,14}$/;
 export const restCountry = /^\+?[1-9]\d{0,2}[\s.-]?\(?\d{1,4}\)?[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/;

export const phoneRegExpUAE = /^971[2-9]\d{7}$|^[2-9]\d{8}$/;

export const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const nameRegEx = /^(?!.*[@#&$^*()])[a-zA-Z\s]+$/;

export const descriptionRegEx = /^(?!.*[@#&$^*()])[a-zA-Z0-9\s]+$/;

export const addressRegEx = /^[A-Za-z0-9\s,.\-#]+(?:\s(?:Apt|Unit|Suite|#)\s?[0-9A-Za-z]+)?(?:\s[A-Za-z\s]+(?:\s[A-Za-z]{2,3})?)?(?:\s\d{5}(-\d{4})?)?$/;

export const findSchool = (slug: any) => {
  switch (slug) {
    case "1":
      return {
        url: "https://www.bateenworldacademy.ae",
        name: "Bateen World Academy",
      };
    case "2":
      return {
        url: "https://www.alainbritishacademy.ae",
        name: "Al Ain British Academy",
      };
    case "3":
      return {
        url: "https://www.yasamericanacademy.ae/",
        name: "Yas American Academy",
      };
    case "4":
      return {
        url: "https://www.yasminabritishacademy.ae",
        name: "Yasmina British Academy",
      };
    case "5":
      return {
        url: "https://www.mamourabritishacademy.ae",
        name: "Mamoura British Academy",
      };
    case "6":
      return {
        url: "https://www.munabritishacademy.ae",
        name: "Muna British Academy",
      };
    case "7":
      return {
        url: "https://virginiaschool.ae",
        name: "Virginia International",
      };
    case "8":
      return { url: "https://www.cranleigh.ae", name: "Cranleigh Abu Dhabi" };
    case "9":
      return { url: "https://kentcollege.sch.ae", name: "Kent College Dubai" };
    case "10":
      return { url: "https://cranleigh.bh", name: "Cranleigh Bahrain" };
    case "11":
      return {
        url: "https://www.pearlbritishacademy.ae",
        name: "Pearl British Academy",
      };
    case "12":
      return { url: "https://noya.sch.ae", name: "Noya British School" };
    case "13":
      return {
        url: "https://www.alshohub.org",
        name: "Al Shohub Private School",
      };
    default:
      return { url: null, name: null };
  }
};

export const encryptData = (data) => {
  // Generate a random initialization vector
  const publicKey = "tY46u6lVlZvo9EQguun6XbSWCrOXft21hk2ViFbgRnosAzFuzFgFxg==";

  const iv = crypto.randomBytes(16);

  // Generate a random symmetric key
  const symmetricKey = crypto.randomBytes(32);

  // Encrypt the data using aes-256-cbc
  const cipher = crypto.createCipheriv("aes-256-cbc", symmetricKey, iv);
  let encryptedData = cipher.update(data, "utf-8", "base64");
  encryptedData += cipher.final("base64");

  // Encrypt the symmetric key with the public key
  const encryptedSymmetricKey = crypto.publicEncrypt(
    {
      key: Buffer.from(publicKey, "base64"),
      padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
    },
    symmetricKey
  );

  return {
    iv: iv.toString("base64"),
    encryptedData: encryptedData,
    encryptedSymmetricKey: encryptedSymmetricKey.toString("base64"),
  };
};

export const compareGrades = (a: any, b: any) => {
  const gradeOrder = {
    PreKG: 0,
    KG1: 1,
    KG2: 2,
    "Grade 1": 3,
    "Grade 2": 4,
    "Grade 3": 5,
    "Grade 4": 6,
    "Grade 5": 7,
    "Grade 6": 8,
    "Grade 7": 9,
    "Grade 8": 10,
    "Grade 9": 11,
    "Grade 10": 12,
    "Grade 11": 13,
    "Grade 12": 14,
  };

  return gradeOrder[a.name["en-US"]] - gradeOrder[b.name["en-US"]];
};

export const compareYears = (a: any, b: any) => {
  const yearOrder = {
    PreFS: 0,
    FS1: 1,
    FS2: 2,
    "Year 1": 3,
    "Year 2": 4,
    "Year 3": 5,
    "Year 4": 6,
    "Year 5": 7,
    "Year 6": 8,
    "Year 7": 9,
    "Year 8": 10,
    "Year 9": 11,
    "Year 10": 12,
    "Year 11": 13,
    "Year 12": 14,
    "Year 13": 15,
  };

  return yearOrder[a.name["en-US"]] - yearOrder[b.name["en-US"]];
};

export const isFormValid = (form: any) => {
  for (let key in form) {
    if (
      (key !== "description" && form[key] === "") ||
      form[key] === "+971" ||
      form[key] === null
    ) {
      return true;
    }
  }
  return false;
};

export const activeClass: any = (
  path?: string,
  name?: string,
  item?: string
) => {
  if (path === name) {
    return "active";
  } else if (path?.toString()?.includes("curri") && item === "Our schools") {
    return "active";
  } else if (path?.toString()?.includes("schools") && item === "Our schools") {
    return "active";
  } else if (path?.toString()?.includes("alumni") && item === "Our students") {
    return "active";
  } else if (
    path?.toString()?.includes("students") &&
    item === "Our students"
  ) {
    return "active";
  } else if (
    path?.toString()?.includes("scholarship") &&
    item === "Our students"
  ) {
    return "active";
  } else if (
    path?.toString()?.includes("international") &&
    item === "Our students"
  ) {
    return "active";
  } else {
    return null;
  }
};

export const addCommasToSchoolCard = (num: number) => {
  return num?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const sortAges = (ageArray) => {
  if (!Array.isArray(ageArray)) {
    return [];
  }

  // Create a shallow copy of the array to avoid mutating the original
  const ageArrayCopy = [...ageArray];

  return ageArrayCopy.sort((a, b) => {
    // Extract numeric age from the "name" field
    const ageA = parseInt(a.name["en-US"].replace(/[^0-9]/g, ""), 10);
    const ageB = parseInt(b.name["en-US"].replace(/[^0-9]/g, ""), 10);

    // Compare numeric values
    return ageA - ageB;
  });
};

export const uniqueItems = (items: any) => {
  const getSchools = items?.data?.allAedschoolpage?.results;

  const uniqueItems =
    Array.isArray(getSchools) &&
    getSchools?.filter(
      (item, index, self) =>
        index === self?.findIndex((t) => t?.name === item?.name)
    );
  return uniqueItems;
};

export const findCurrentStep = (step: string) => {
  switch (step) {
    case "InitialPage":
      return 1;

    case "studentInformation":
      return 2;

    case "parentinformation":
      return 3;

    case "previousSchool":
      return 4;

    case "otherInformation":
      return 5;

    case "documentupload":
        return 6;

    default:
      return 0;
  }
};


export const trimedText = (file:string,maxLength:number) => {
    if (file?.length > maxLength) {
      return `${file?.slice(0, maxLength)}...`;
    }
    return file;
}

export const createFieldValidation = (fieldConfig, customPattern) => {
  if (!fieldConfig || typeof fieldConfig !== 'object') return Yup.string().nullable();

    if (!fieldConfig?.mandatory && !fieldConfig?.minlength && !fieldConfig?.maxlength) {
      return Yup.string().nullable();
    }
  
  // Initialize the validation schema
  let validationSchema = Yup.string();

  // Apply min and max length validations if provided
  if (fieldConfig?.minlength) validationSchema = validationSchema.min(fieldConfig.minlength, TOO_SHORT);
  if (fieldConfig?.maxlength) validationSchema = validationSchema.max(fieldConfig.maxlength, TOO_LONG);

  // Apply regex validation if provided (either custom or from fieldConfig)
  const regex = customPattern || fieldConfig?.regexvalidation;
  if (regex) validationSchema = validationSchema.matches(regex, SPECIAL_CHAR_NOT_ALLOWED);

  // Apply required validation message
  validationSchema = validationSchema.required(fieldConfig?.validationmessage || "This field is required");

  return validationSchema;
};

export const formatEmiratesId = (input: string) => {
  if(!input){
    return;
  }
  // Convert input to string to work with it
  let str = input?.toString();
  
  // Format the string into the desired pattern
  let formatted = str.substring(0, 3) + '-' + str.substring(3, 7) + '-' + str.substring(7, 14) + '-' + str.substring(14);
  
  return formatted;
};

export const nameValidation = "^[A-Za-z ]+$";

export const nameFormat = (value:any) =>{
  const capitalizedValue = value
      .split(' ') // Split the input string into words
      .map(word => 
        word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''
      ) // Capitalize each word, convert the rest to lowercase
      .join(' ');
  
  return capitalizedValue;
};

export const formatApplicationEmiratesId = (inputValue) => {
  // Remove non-numeric characters
  inputValue = inputValue.replace(/\D/g, '');

  // Limit to 15 characters
  if (inputValue.length > 15) {
    inputValue = inputValue.slice(0, 15);
  }

  // Format the input as 784-1945-1234567-0
  let formattedValue = inputValue;

  if (formattedValue.length > 3) {
    formattedValue = formattedValue.slice(0, 3) + '-' + formattedValue.slice(3);
  }
  if (formattedValue.length > 8) {
    formattedValue = formattedValue.slice(0, 8) + '-' + formattedValue.slice(8);
  }
  if (formattedValue.length > 16) {
    formattedValue = formattedValue.slice(0, 16) + '-' + formattedValue.slice(16);
  }

  return formattedValue;
};



export const encryptResponse  = (val: any,secrteKey:string): string => {
  try {
      const key = CryptoJS.enc.Utf8.parse(secrteKey);
      const iv = CryptoJS.enc.Utf8.parse(secrteKey);
      const stringifiedValue = JSON.stringify(val);

      const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(stringifiedValue), key, {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
      });

      // Return ciphertext in Base64 format
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  } catch (error: any) {
      console.error("Error during encryption:", error.message);
      throw new Error("Encryption failed: " + error.message);
  }
};

export const decryptPostResponse = (val: string,secrteKey:string): any => {
  try {
      const key = CryptoJS.enc.Utf8.parse(secrteKey);
      const iv = CryptoJS.enc.Utf8.parse(secrteKey);

      // Decrypt the Base64 encoded ciphertext
      const bytes = CryptoJS.AES.decrypt(
          { ciphertext: CryptoJS.enc.Base64.parse(val) } as any,
          key,
          {
              keySize: 128 / 8,
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7,
          }
      );

      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedString) {
          throw new Error("Decryption resulted in an empty string");
      }

      // Parse and return JSON data
      return JSON.parse(decryptedString);
  } catch (error: any) {
      console.error("Error during decryption:", error.message);
      throw new Error("Decryption failed: " + error.message);
  }
};


export const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;

  if (
    obj1 === null ||
    obj2 === null ||
    typeof obj1 !== "object" ||
    typeof obj2 !== "object"
  ) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};


export const handleApplicationRedirection = (dispatch, schoolName) => {
  // console.log("schoolName¬¬¬¬¬", schoolName);
  if (!dispatch || !schoolName) {
    console.error("Invalid input: dispatch and schoolName are required");
    return;
  }

  try {
    dispatch(setSchoolName(schoolName));
    dispatch(setCurrentStep(1));
  } catch (error) {
    console.error("Error handling application redirection:", error);
  }
};


export const repeatingPatternRegex = /\b(\w+)\b.*\b\1\b|\b(\w{2,})\2+\b/i;



 export const datadoglogFormData = (stepperName, userEvent, userSfId, userApplicationId, formVal) => {
    datadogLogs.logger.info(stepperName, {
      event: userEvent,
      sfid : userSfId,
      applicationId: userApplicationId,
      formData: formVal,
    });
  }; 

  export const trackGtmEvent = (eventLabel) => {
    
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "button_click", {
        event_category: "User Interaction",
        event_label: eventLabel,
        value: 1
      });
    }
  };

 export const trackStepEvent = (step) => {

    const eventMap = {
      1: "Academic_Info",
      2: "Student_Information",
      3: "Parent_Information",
      4: "Previous_School",
      5: "Other_Details",
      6: "Files",
    };
  
    const eventName = eventMap[step];
    if (eventName) {
      trackGtmEvent(eventName);
    }
  };
  